export default function Hero() {
  return (
    <section className="relative flex min-h-[640px] items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Epic%20anime%20style%20hero%20banner%20of%20a%20young%20ninja%20in%20orange%20and%20black%20attire%20mid%20jump%20with%20spinning%20fire%20and%20lightning%20energy%20around%20him%2C%20warm%20orange%20and%20crimson%20dramatic%20sky%2C%20floating%20embers%2C%20dynamic%20and%20cinematic%2C%20high%20detail%20digital%20painting%2C%20powerful%20composition&width=1600&height=900&seq=hero-naruto-fan&orientation=landscape"
        alt="火影同人游戏热血首屏背景图"
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/70"></div>

      <div className="relative z-10 mx-auto w-full max-w-4xl px-4 text-center md:px-6">
        <p className="inline-flex items-center gap-2 rounded-full bg-white/15 px-4 py-1.5 text-xs font-medium tracking-wide text-amber-200 backdrop-blur">
          <i className="ri-fire-line"></i>
          手机版 · 电脑版 · 安卓 · 汉化 · 免安装
        </p>
        <h1 className="font-heading mt-6 text-4xl font-black leading-tight text-white md:text-6xl">
          火影同人游戏下载
          <span className="mt-2 block text-primary-400">一站集齐 · 畅快开玩</span>
        </h1>
        <p className="mx-auto mt-6 max-w-2xl text-base leading-8 text-white/85 md:text-lg">
          精选各类火影同人游戏资源，覆盖安卓、iOS、Windows 与 macOS 多平台，汉化版与免安装版全都有。不用再四处翻找，按平台点进去就能拿到安装包与启动方式。
        </p>

        <div className="mt-9 flex flex-col items-center justify-center gap-4 sm:flex-row">
          <a
            href="#library"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById("library")?.scrollIntoView({ behavior: "smooth" });
            }}
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-8 py-3.5 text-base font-semibold text-white transition-all hover:bg-primary-600 hover:-translate-y-0.5"
          >
            <i className="ri-download-2-line"></i>
            浏览游戏资源
          </a>
          <a
            href="#guide"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById("guide")?.scrollIntoView({ behavior: "smooth" });
            }}
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-white/40 bg-white/10 px-8 py-3.5 text-base font-semibold text-white backdrop-blur transition-colors hover:bg-white/20"
          >
            <i className="ri-book-open-line"></i>
            查看下载指南
          </a>
        </div>

        <div className="mx-auto mt-12 grid max-w-2xl grid-cols-2 gap-4 sm:grid-cols-4">
          {[
            { num: "6+", label: "同人游戏资源" },
            { num: "5", label: "主流平台" },
            { num: "580万+", label: "累计下载" },
            { num: "24h", label: "持续更新" },
          ].map((s) => (
            <div key={s.label} className="rounded-lg bg-white/10 p-4 backdrop-blur">
              <p className="font-heading text-2xl font-bold text-amber-300">{s.num}</p>
              <p className="mt-1 text-xs text-white/75">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}